import React, { useEffect, useState, useRef } from "react";
import "./PauseCourse.scss";
import axios from "axios";
import right from "../../../assets/images/icons/right-arrow.svg";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import { addPauseDays, newPauseError, schoolToday, MIN_PAUSE_DAYS, MAX_PAUSE_DAYS } from "./pauseRules";

const PauseCourse = ({ studentPause, studentPauseMsg }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [saving, setSaving] = useState(false);
  const saveLock = useRef(false);
  const [pauseEligibility, setPauseEligibility] = useState(null);
  const [historyError, setHistoryError] = useState(false);

  const handleStartDateChange = (e) => {
    const selectedDate = e.target.value;

    // Validate the selected date
    if (!selectedDate) {
      toast("Please select a valid start date.");
      return;
    }

    // Set the start date
    setStartDate(selectedDate);

    setEndDate(addPauseDays(selectedDate, MIN_PAUSE_DAYS));
  };

  const pauseCourse = async () => {


    const formData = new FormData();
    formData.append("pause_start", startDate);
    formData.append("pause_end", endDate);

    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const login_school_id = localStorage.getItem("session_school_id");
    const login_user_status = localStorage.getItem("session_user_status");

    if (saveLock.current) return;
    const validationError = newPauseError(startDate, endDate);
    if (validationError) { toast.error(validationError); return; }
    saveLock.current = true;
    setSaving(true);

    const url = `${process.env.REACT_APP_API_BASE_URL}/?&status=${login_user_status}&login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=addPauseStudentRequest&school_id=${login_school_id}`;

    try {
      const resp = await axios.post(url, formData);
      if (resp.data.status === true) {
        toast.success(resp.data.message);
        setStartDate(""); setEndDate("");
        await pauseHistoryDetails();
      } else { toast.error(resp.data.message || 'Pause was not saved. Please try again.'); }
    } catch (error) {
      toast.error('Pause could not be saved. Your dates have been retained.');
    } finally {
      saveLock.current = false;
      setSaving(false);
    }

  };

  const [data, setData] = useState([]);

  const pauseHistoryDetails = async () => {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const login_user_status = localStorage.getItem("session_user_status");
    const login_school_id = localStorage.getItem("session_school_id");

    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${encodeURIComponent(login_cookie || '')}&login_action_type=${login_action_type}&status=${login_user_status}&login_user_id=${login_user_id}&f=myPauseStudentRequestList&school_id=${login_school_id}`
      );
      if (resp.data.status !== true) { setHistoryError(true); return; }
      setHistoryError(false);
      setPauseEligibility({ allowed: resp.data.can_request_new_pause, message: resp.data.pause_limit_message });
      if (resp?.data?.data?.length > 0) {
        setData(resp?.data?.data);
      } else {
        setData([]);
      }
    } catch (error) {
      setHistoryError(true);
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    }
  };

  useEffect(() => {
    pauseHistoryDetails();
  }, []);

  return (
    <div className="place_absence_section">
      <ToastContainer />
      <div className="container-fluid">
        <div className="user_detail">
          <div className="place_absence_title">
            <h2>Pause Course</h2>
            <p>New pauses: once within 365 days, starting from tomorrow, for 21–184 days. Extending an existing pause does not count as a new pause; its total duration must remain within 184 days.</p>
          </div>
        </div>
        <div className="place_absence">
          {pauseEligibility?.allowed === true ? (
            <div className="place_absence_inner">
              <div className="place_absence_calender">
                <form className="row">
                  <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <label htmlFor="inputStartdate" className="form-label">
                      SELECT <span>START</span> DATE
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputStartdate"
                      value={startDate}
                      min={addPauseDays(schoolToday(), 1)}
                      onChange={handleStartDateChange}
                    />
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                    <div className="arrow_img">
                      <img className="img-fluid" src={right} alt="" />
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <label htmlFor="inputEnddate" className="form-label">
                      SELECT <span>END</span> DATE
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputEnddate"
                      value={endDate}
                      min={startDate ? addPauseDays(startDate, MIN_PAUSE_DAYS) : addPauseDays(schoolToday(), 1)}
                      max={startDate ? addPauseDays(startDate, MAX_PAUSE_DAYS) : ""}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        setEndDate(selectedDate);
                      }}
                    />
                  </div>
                </form>
              </div>
              <div className="absent_btn mt-5">
                <button
                  className="btn btn_primary"
                  type="submit"
                  onClick={pauseCourse}
                  disabled={saving}
                >
                  {saving ? "SAVING…" : "SUBMIT"}
                </button>
              </div>
            </div>
          ) : (
            <div className="alert alert-danger mt-2" role="alert">
              {historyError ? 'Pause details could not be loaded. Please reload before requesting a pause.' : pauseEligibility?.message || 'Loading pause details…'}
            </div>
          )}
        </div>
      </div>
      <div className="courses_section">
        <div className="container-fluid">
          <div className="my_courses">
            <div className="user_detail">
              <div className="courses_title">
                <h2>Pause History</h2>
              </div>
            </div>
            <div className="courses">
              <div className="courses_inner">
                <div className="courses_cards row">
                  {data?.length ? (
                    data?.map((item, index) => (
                      <Link
                        className="courses_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                        key={`${index}-Card`}
                      >
                        <div className="courses_card_inner">
                          <div className="courses_detail">
                            <ul className="courses_list">
                              <li className="courses_item">
                                <span>Start Date :</span>
                                <span>{item?.start_date}</span>
                              </li>
                              <li className="courses_item">
                                <span>End Date :</span>
                                <span>{item?.end_date}</span>
                              </li>
                              <li className="courses_item">
                                <span>Requested Date :</span>
                              <span>{item?.requested_date || 'Not recorded'}</span>
                              </li>
                              {/* <li className="courses_item">
                                <span>Status :</span>
                                <span>
                                  {item?.status}
                                </span>
                              </li> */}
                            </ul>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <Link className="courses_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                      <div className="courses_card_inner">
                        <div className="courses_detail">
                          <ul className="courses_list">
                            <li className="courses_item">
                              <span>{historyError ? 'Pause history could not be loaded' : pauseEligibility === null ? 'Loading pause history…' : 'No Pause History Available'}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PauseCourse;
